import { render, staticRenderFns } from "./app-chat.vue?vue&type=template&id=1b383e9a&"
import script from "./app-chat.vue?vue&type=script&lang=js&"
export * from "./app-chat.vue?vue&type=script&lang=js&"
import style0 from "./app-chat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports